import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('notes-widget', (editor, opts = {}) => {
  let options = opts || {};

  let defaults = {
    pfx: 'notes-widget',
    blocks: ['notes-widget'],
    defaultStyle: true,
    label: 'Notes',
    category: 'Advanced',
    type: 'notes-widget',
     labelColName: 'Collection',
    labelFieldName: 'Collection Fields',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
 
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
